export enum AdminRoutes {
  //Dashboard = 'dashboard',
  Seance = 'seance',
  Settings = 'settings',
  Elements = 'elements',
}

export enum ParametresRoutes {
  //Dashboard = 'dashboard',
  Direction = 'direction',
}

export enum ElementRoutes {
  Alert = 'alert',
  Modal = 'modal',
  Buttons = 'buttons',
  Tabs = 'tabs',
  DataTable = 'data-table',
  Forms = 'forms',
}

export enum SettingRoutes {
  Profile = 'profile',
  Users = 'users',
}
